import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";

/**
 * Mobile-only sticky CTA bar. Appears after user scrolls past hero.
 * Hidden on /admin routes and on the /contact and /support pages themselves.
 */
export default function MobileStickyCTA() {
    const [show, setShow] = useState(false);
    const loc = useLocation();
    const hidden = loc.pathname.startsWith("/admin") || loc.pathname === "/contact" || loc.pathname === "/support";

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 480);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (hidden) return null;

    return (
        <div
            data-testid="mobile-sticky-cta"
            className={`md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-line bg-bg/95 backdrop-blur transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
        >
            <div className="flex">
                <a
                    href="tel:+16046714247"
                    className="flex-1 flex items-center justify-center gap-2 py-3.5 text-[13px] text-ink border-r border-line"
                >
                    <Phone className="w-4 h-4" /> Call
                </a>
                <Link
                    to="/contact"
                    className="flex-[1.4] flex items-center justify-center gap-2 py-3.5 text-[13px] font-medium bg-ink text-bg border-t-2 border-gold"
                >
                    Request a Site Assessment <ArrowUpRight className="w-4 h-4" />
                </Link>
            </div>
        </div>
    );
}
